<template>
  <span class="proa-error-badge"/>
</template>

<script>
export default {
  name: 'ProaErrorBadge'
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.proa-error-badge {
  position: relative;

  &:before {
    position: absolute;
    top: -25px;
    content: "！";
    display: inline-block;
    text-align: center;
    font-weight: 600;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 6px;
    background-color: $error-color;
    color: white;
  }

  &:after {
    content: "";
    position: absolute;
    top: -6px;
    left: 6px;
    border: 4px solid transparent;
    border-top: 6px solid $error-color;
  }
}
</style>
